export default "__VITE_ASSET__CTbQ3Rds__"